import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Gift } from 'lucide-react';
const bonos = [{
  id: 1,
  icon: '🎵',
  title: '100 Cues Verbales Listos',
  value: '12.000',
  subtitle: 'Nunca más quedarte sin palabras en clase',
  content: ['100 instrucciones verbales categorizadas por postura', 'Cómo corregir sin tocar al alumno/a', 'Frases de motivación y cierre de clase', 'Cues para calentamiento, desarrollo y meditación final', 'Lenguaje inclusivo y profesional listo para usar', 'Separado por tipo de postura: de pie, suelo, equilibrio', 'Versiones suaves para clases restaurativas', 'Versiones motivadoras para power yoga y vinyasa', 'Traducciones al sánscrito cuando corresponde', 'Listo para leer, adaptar o memorizar']
}, {
  id: 2,
  icon: '📋',
  title: 'Planificador Mensual de Clases',
  value: '9.000',
  subtitle: 'Tu mes completo ya organizado y listo para ejecutar',
  content: ['Calendario de 4 semanas con clases ya asignadas', 'Por nivel y objetivo semanal', 'Versión para clases grupales y privadas', 'Espacio para personalizar con tus grupos', 'Progresión lógica semana a semana', 'Incluye semana de recuperación activa', 'Checklist semanal del profe', 'Sistema de notas por alumno', 'Compatible con estudio presencial y online', 'Imprimible o editable en digital']
}, {
  id: 3,
  icon: '📐',
  title: 'Secuencias Express de 30 Minutos',
  value: '8.000',
  subtitle: 'Para cuando el tiempo es corto pero el valor debe ser máximo',
  content: ['10 secuencias de 30 min completas y listas', 'Clasificadas por objetivo: energía, relax, fuerza, flexibilidad', 'Con imagen de cada postura principal', 'Tiempos por postura incluidos', 'Transiciones descriptas paso a paso', 'Funciona como clase completa o como cierre', 'Ideal para clases express, empresas o sesiones privadas', 'Sin necesidad de materiales adicionales', 'Adaptaciones para cada nivel', 'Listo para usar desde el primer día']
}, {
  id: 4,
  icon: '🧘',
  title: 'Meditaciones Guiadas — Guión Listo',
  value: '10.000',
  subtitle: 'Cierres de clase que los alumnos recuerdan toda la semana',
  content: ['8 meditaciones guiadas completas (5 a 15 minutos)', 'Gratitud, soltar, abundancia, sueño, energía, autoestima, presencia, sanación', 'Técnicas de Pranayama incluidas en cada meditación', 'Guión listo para leer o adaptar con tu voz', 'Indicaciones de tono y velocidad de lectura', 'Música sugerida para cada meditación', 'Versión corta (5 min) y versión extendida (15 min)', 'Adaptadas para grupos y para sesiones individuales', 'Lenguaje inclusivo y no religioso', 'Nivel de experiencia: todas las instructoras']
}, {
  id: 5,
  icon: '📅',
  title: 'Fichas de Alumnos y Evaluación',
  value: '9.000',
  subtitle: 'Las herramientas que te hacen ver como la profe más profesional del estudio',
  content: ['Ficha de inscripción y salud completa', 'Evaluación inicial de movilidad y flexibilidad', 'Formulario de progreso mensual', 'Encuesta de satisfacción para retener alumnos', 'Ficha especial para alumnos con condiciones especiales', 'Registro de asistencia mensual', 'Planilla de seguimiento de objetivos personales', 'Formulario de reincorporación tras lesión o pausa', 'Waiver de responsabilidad listo para firmar', '100% adaptado a la normativa argentina']
}, {
  id: 6,
  icon: '📱',
  title: 'Kit de Contenido para Redes',
  value: '8.000',
  subtitle: '30 días de contenido profesional listo para publicar',
  content: ['30 ideas de posts con texto listo para copiar y pegar', 'Frases motivacionales para historias de Instagram', 'Ideas de Reels y videos cortos con guión', 'Bio optimizada para Instagram y TikTok', '18 flyers adaptables para WhatsApp y stories', 'Hashtags por nicho y ciudad argentina', 'Calendario de publicación sugerido (3 veces por semana)', 'Ideas de contenido educativo para posicionarte como referente', 'Textos para captar alumnos nuevos orgánicamente', 'Branding visual sugerido alineado a tu estilo']
}];
export function BonosAccordion() {
  const [openId, setOpenId] = useState<number | null>(null);
  const toggleAccordion = (id: number) => {
    setOpenId(openId === id ? null : id);
  };
  return <section className="py-12 md:py-24 bg-white relative" data-id="element-16">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-17">
        <div className="text-center mb-8 md:mb-16" data-id="element-18">
          <div className="inline-flex items-center justify-center p-2 md:p-3 bg-yoga-gold/10 rounded-full mb-3 md:mb-4" data-id="element-19">
            <Gift className="w-6 h-6 md:w-8 md:h-8 text-yoga-gold-600" data-id="element-20" />
          </div>
          <h2 className="text-2xl md:text-5xl font-serif font-bold text-gray-900 mb-2 md:mb-4" data-id="element-21">
            INCLUIDOS GRATIS
          </h2>
          <p className="text-base md:text-xl text-yoga-purple-600 font-medium" data-id="element-22">
            6 BONOS ESTRATÉGICOS
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-23">
          {bonos.map(bono => {
          const isOpen = openId === bono.id;
          return <div key={bono.id} className={`rounded-xl md:rounded-2xl overflow-hidden transition-all duration-300 border-2 ${isOpen ? 'border-yoga-gold shadow-[0_0_20px_rgba(212,175,55,0.2)]' : 'border-gray-100 shadow-sm hover:border-yoga-gold/30'}`} data-id="element-24">
                <button onClick={() => toggleAccordion(bono.id)} className="w-full flex flex-col sm:flex-row sm:items-center justify-between p-4 md:p-6 text-left transition-colors bg-white hover:bg-gray-50 gap-3 md:gap-4" data-id="element-25">
                  <div className="flex items-center gap-3 md:gap-4" data-id="element-26">
                    <div className="text-2xl md:text-3xl" data-id="element-27">{bono.icon}</div>
                    <div data-id="element-28">
                      <div className="text-xs md:text-sm font-bold tracking-wider uppercase mb-0.5 md:mb-1 text-yoga-purple-600" data-id="element-29">
                        BONO {bono.id}
                      </div>
                      <h3 className="text-base md:text-xl font-serif font-bold text-gray-900" data-id="element-30">
                        "{bono.title}"
                      </h3>
                    </div>
                  </div>

                  <div className="flex items-center justify-between sm:justify-end gap-4 md:gap-6 w-full sm:w-auto pl-11 sm:pl-0" data-id="element-31">
                    <div className="text-right" data-id="element-32">
                      <div className="text-xs md:text-sm text-gray-400 line-through" data-id="element-33">
                        Valor: ${bono.value}
                      </div>
                      <div className="text-sm md:text-lg font-bold text-green-600 bg-green-50 px-2 md:px-3 py-0.5 md:py-1 rounded-full border border-green-200" data-id="element-34">
                        GRATIS
                      </div>
                    </div>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-35">
                      <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 ${isOpen ? 'text-yoga-gold' : 'text-gray-400'}`} data-id="element-36" />
                    </motion.div>
                  </div>
                </button>

                <AnimatePresence data-id="element-37">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="bg-yoga-purple-50/50" data-id="element-38">
                      <div className="p-4 md:p-8 border-t border-yoga-gold/20" data-id="element-39">
                        <p className="text-yoga-purple-900 font-semibold text-sm md:text-lg mb-4 md:mb-6 pb-3 md:pb-4 border-b border-yoga-purple-200/50" data-id="element-40">
                          {bono.subtitle}
                        </p>
                        <ul className="space-y-2 md:space-y-3" data-id="element-41">
                          {bono.content.map((item, idx) => <li key={idx} className="flex items-start gap-2 md:gap-3 text-gray-700 text-sm md:text-base" data-id="element-42">
                              <span className="text-yoga-gold mt-0.5 text-base md:text-lg" data-id="element-43">
                                ✓
                              </span>
                              <span className="leading-relaxed" data-id="element-44">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <motion.div className="mt-8 md:mt-12 text-center bg-yoga-purple-900 text-white p-5 md:p-8 rounded-xl md:rounded-2xl border border-yoga-gold/30 shadow-xl" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-45">
          <p className="text-sm md:text-lg text-yoga-purple-200 mb-1 md:mb-2" data-id="element-46">
            VALOR TOTAL DE LOS 6 BONOS:{' '}
            <span className="line-through" data-id="element-47">$56.000</span>
          </p>
          <h3 className="text-2xl md:text-4xl font-bold text-yoga-gold" data-id="element-48">
            GRATIS
          </h3>
          <p className="mt-1 md:mt-2 text-xs md:text-sm text-yoga-purple-100" data-id="element-49">
            Incluidos siempre en ambas ofertas
          </p>
        </motion.div>
      </div>
    </section>;
}